import { themeConWeb } from '@foodsby/nutrient'
import { Container, Link } from '@material-ui/core'
import { ArrowBackIos } from '@material-ui/icons'
import React from 'react'
import { withRouter } from 'react-router-dom'
import Sticky from 'react-sticky-el'
import styled from 'styled-components'

export const NavSubBack = ({ history }) => (
  <Sticky stickyStyle={{ zIndex: 100 }}>
    <Component>
      <Container className="-container" maxWidth="lg">
        <Link className="-action" component="button" onClick={history.goBack}>
          <ArrowBackIos className="-glyph" /> BACK
        </Link>
      </Container>
    </Component>
  </Sticky>
)

const Component = styled.nav`
  background-color: ${themeConWeb.color.three};
  top: 0;
  z-index: 100;

  & .-container {
    align-items: center;
    display: flex;
    height: calc(${themeConWeb.baseUnit} * 13);
  }

  & .-action {
    color: ${themeConWeb.color.brandPrimaryTint3};
    display: flex;
    // TODO hack until we nail down our font scale
    font-size: 16px;
    align-items: center;
  }

  & .-glyph {
    font-size: 16px;
    width: 20px;
  }
`

export default withRouter(NavSubBack)
